import React from "react";
import { Button } from "semantic-ui-react";
import { ModalBuilder, Modal } from "@redriver/cinnamon";
import { downloadFile } from "./actions";
import FileSaver from "file-saver";

const DownloadFile = ({ id }) => {
  return (
    <ModalBuilder
      submitAction={downloadFile}
      submitParams={{ id }}
      onSubmitted={result => {
        result && FileSaver.saveAs(result, `${id}.xlsx`);
      }}
      renderTrigger={showModal => (
        <Button
          primary
          onClick={showModal}
          title="Download"
          icon="download"
          className="download-btn"
        />
      )}
      renderModal={modalProps => (
        <Modal.Confirmation {...modalProps} header="Download File">
          Are you sure you want to download the upload spreadsheet file?
        </Modal.Confirmation>
      )}
    />
  );
};

export default DownloadFile;
